export const visibleText = (html: string): string => {
  const template = document.createElement('template');
  template.innerHTML = html;
  template.content.querySelectorAll('script, style').forEach(node => node.remove());
  template.content.querySelectorAll('br, p, div, li, h1, h2, h3, h4, h5, h6, blockquote, tr, td, th').forEach(node => {
    node.before('\n');
    node.after('\n');
  });

  return (template.content.textContent ?? '')
    .replace(/\u00a0/g, ' ')
    .split(/\r\n?|\n/)
    .map(line => line.trim())
    .filter(line => line !== '')
    .join('\n');
};

export const visibleLength = (html: string): number => [...visibleText(html)].length;
